export default __webpack_public_path__ + "static/media/img6.f2ce16a4.png";